<section class="landing-inversores__why landing-inversores__container">
  <div class="landing-inversores__why-grid">
    <div class="landing-inversores__card landing-inversores__value-card" *ngFor="let v of whyInviertis">
      <landing-inversores-icon [name]="v.icon" class="landing-inversores__value-card-icon"></landing-inversores-icon>
      <h3 class="landing-inversores__value-card-title">{{ v.title }}</h3>
      <p class="landing-inversores__value-card-desc">{{ v.desc }}</p>
    </div>
  </div>
</section>
